import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';
import {FiPhoneCall, FiMail,FiMapPin} from '../assets/icons/vander'
import QRAppRegister from "../assets/images/personal/qr-app-register.png"

export default function GetInTuchCustom(){
    const [responseMessage, setResponseMessage] = useState("");
    const [formData, setFormData] = useState({
            name: "",
            email: "",
            phone: "",
            schedule: "",
            comments: "",
            termsAccepted: false,
        });
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
            }));
        };
        const handleSubmit = async (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            try {
                const { protocol, hostname, port, pathname } = window.location;
                let url = `${protocol}//${hostname}${port ? `:${port}` : ''}/contact2.php`;
                const response = await fetch(url, {
                    method: "POST",
                    body: formData
                });
                const data = await response.json();
                setResponseMessage(data.message || "Form submitted successfully!");
                setFormData({name:"", email:"", phone:"", schedule:"", comments:"", termsAccepted:false});
            } catch (error) {
                setResponseMessage("Error submitting the form.");
            }
        };
    return(
        <section className="section" id="nosotrosTeLlamamos" style={{ paddingTop:'1rem' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="section-title mb-4">
                        <h4 className="title mb-4"><br/>Primera clase gratis</h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="section-title mb-4">
                        <h4 className="title mb-4">Regístrate a través de nuestra APP</h4>
                    </div>

                    <div className="row">
                        <div className="col-12 mt-4">
                            <div className="d-flex features feature-primary">
                                <img src={ QRAppRegister } style={{ width:'100%' }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-8 col-md-6 col-12 mt-4 pt-2 mt-sm-0 pt-sm-0">
                    <div className="p-4 rounded shadow">
                        <h4 className="title mb-4">Rellena el formulario y ¡te llamamos!</h4>
                        <form id="contact-form" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Su nombre <span className="text-danger">*</span></label>
                                        <input name="name" id="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            type="text" className="form-control" required/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Su correo <span className="text-danger">*</span></label>
                                        <input name="email" id="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            type="email" className="form-control" required/>
                                    </div> 
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Su telefono <span className="text-danger">*</span></label>
                                        <input name="phone" id="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            type="text" className="form-control" required minLength={9} maxLength={9} />
                                    </div> 
                                </div>

                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">¿En qué horario prefiere que le llamemos? <span className="text-danger">*</span></label>
                                        <select name="schedule" id="schedule"
                                                value={formData.schedule}
                                                onChange={handleChange}
                                                className="form-control" required>
                                            <option value="">Seleccionar horario</option>
                                            <option value="09:00AM">09:00 AM</option>
                                            <option value="10:00AM">10:00 AM</option>
                                            <option value="11:00AM">11:00 AM</option>
                                            <option value="12:00PM">12:00 PM</option>
                                            <option value="01:00PM">01:00 PM</option>
                                            <option value="02:00PM">02:00 PM</option>
                                            <option value="03:00PM">03:00 PM</option>
                                            <option value="04:00PM">04:00 PM</option>
                                            <option value="05:00PM">05:00 PM</option>
                                            <option value="06:00PM">06:00 PM</option>
                                            <option value="07:00PM">07:00 PM</option>
                                            <option value="08:00PM">08:00 PM</option>
                                            <option value="09:00PM">09:00 PM</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">¿En que podemos ayudarle? <span className="text-danger">*</span></label>
                                        <textarea name="comments" id="comments"
                                            value={formData.comments}
                                            onChange={handleChange}
                                            rows="4" className="form-control" required></textarea>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <input type="checkbox" id="privay-policy2" name="termsAccepted" required
                                        checked={formData.termsAccepted}
                                        onChange={handleChange} />
                                    <label for="privay-policy2">He leído y acepto la <Link1 to="#" className="lightbox text-primary">política de privacidad</Link1></label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <p className="text-primary text-center">{responseMessage}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-grid">
                                        <button type="submit" id="submit" name="send" className="btn btn-primary">Enviar mensaje</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}